<template>
    <a :href="createUrl">
        <div class="icon-button icon-button--primary">
            <div class="icon-button__icon">
                <img src="/images/icons/create.svg" alt="">
            </div>
        </div>
    </a>
</template>

<script>

export default {
    props: ['createUrl'],
};
</script>
